<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">

      <div class="view__panel">
        <div class="form js-form">
          <submenu v-if="this.$route.params.id"></submenu>

          <TextBox
            label="Settings_Group_Name"
            v-model="name"
            :validate="$v"
            v-on:input="$v.name.$touch"
            modelPath="name"
            acc="name"
          />

          <TextBox
            label="Settings_Group_Description"
            v-model="description"
            :validate="$v"
            v-on:input="$v.description.$touch"
            modelPath="description"
            :multiLine="true"
            acc="description"
          />

          <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
          <Btn v-on:click="$router.push({name: 'groups'})" label="Label_CancelButton" :withBorder="true" />
        </div>
      </div>
    </article>

  </article>
</template>

<script>
import { TextBox, Btn } from 'components/layout/forms'
import Submenu from 'components/views/groups/Submenu'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'

export default {
  name: 'group',
  components: { Submenu, Validation, TextBox, Btn },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      title: L.localize('Label_Create'),
      id: '',
      name: '',
      description: '',
      L: L
    }
  },
  validations: {
    name: { required },
    description: { required }
  },
  beforeCreate() {
    if (this.$route.params.id) {
      this.$store.dispatch('getGroup', this.$route.params.id).then(() => {
        this.mapFromState()
      })
    }
  },
  computed: {
    ...mapGetters({
      group: 'activeGroup',
      validation: 'getValidation'
    })
  },
  methods: {
    mapFromState() {
      this.id = this.group.id
      this.name = this.group.name
      this.description = this.group.description
      this.title = this.group.name
    },
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loading = true
      let group = {
        id: this.id,
        name: this.name,
        description: this.description
      }
      this.$store.dispatch('createOrUpdateGroup', group).then(
        // resolve
        () => {
          this.loading = false
          if (group.id === '') {
            this.$router.push({name: 'group', params: { id: this.group.id }})
            this.showNotification({
              title: L.localize('Label_SuccessCreation'),
              message: L.localize('Label_Success')
            })
          } else {
            this.mapFromState()
            this.showNotification({
              title: L.localize('Label_SuccessEdit'),
              message: L.localize('Label_Success')
            })
          }
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// Group.vue?bcb82c46